import { render } from "./NotificationToast.vue?vue&type=template&id=558796b4"
import script from "./NotificationToast.vue?vue&type=script&lang=js"
export * from "./NotificationToast.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__